import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { colorsSystem } from '@common/util/defaultValues';
import * as commonActions from '@common/common.action';
import * as actions from '../solicitacao.action';
import SolicitacaoApi from '../solicitacao.api';
import { Badge } from 'reactstrap';
import Filtro from './Filtro';
import Grid from './Grid';
import ModalDetalhesSolicitacao from './Detalhes';
import Relatorio from './Relatorio';
import { returnParamiters, statusSolicitacoesEnum } from '../solicitacao.utils';
import { useIntl } from 'react-intl';
import IntlMessage from '../../../helpers/intlMessage';
import CommonFunctions from '@common/util/functions.common';

function Solicitacoes () {
  const intl = useIntl()
  const dispatch = useDispatch();
  const listaSolicitacoes = useSelector(state => state.solicitacao.listaSolicitacoes);
  const language = localStorage.getItem('currentLanguage')
  const [filtro, setFiltro] = useState({});
  const [total, setTotal] = useState(0);
  const [pagina, setPagina] = useState(1);
  const [showModalDetalhes, setShowModalDetalhes] = useState(false);
  const [itemSelecionado, setItemSelecionado] = useState({});
  const [showBtnImprimir, setShowBtnImprimir] = useState(false);
  const [showModalImprimir, setShowModalImprimir] = useState(false);

  useEffect(() => {
    dispatch(actions.setLista([]));
  }, []);

  useEffect(() => {
    const { tipo } = filtro;
    tipo && filtrar(filtro);
  }, [pagina, language]);

  useEffect(() => {
    if (!showModalDetalhes && itemSelecionado.id) {
      const newList = listaSolicitacoes.map(item =>
        item.id === itemSelecionado.id ? itemSelecionado : item
      );
      dispatch(actions.setLista(formatItens(newList)));
    }
  }, [showModalDetalhes, itemSelecionado, language]);

  useEffect(() => {
    setShowBtnImprimir(false);
  }, [filtro]);

  const onclickLine = item => {
    setItemSelecionado(item.data);
    setShowModalDetalhes(true);
  };

  const filtrar = async filtro => {
    const {
      usuarioExecutante,
      usuarioSolicitante,
      periodoInicial,
      periodoFinal,
      tipo,
      value
    } = filtro;

    let params = returnParamiters({
      periodoInicial,
      periodoFinal,
      tipo,
      value
    });

    if (tipo.indexOf('dt') >= 0) {
      if (params.dataInicio.includes('/')) {
        let partes = params.dataInicio.split('/');
        params.dataInicio = partes[2] + '-' + partes[1] + '-' + partes[0];
      }

      if (params.dataFim.includes('/')) {
        let partes = params.dataFim.split('/');
        params.dataFim = partes[2] + '-' + partes[1] + '-' + partes[0];
      }

      const result = CommonFunctions.validaData(params.dataInicio, params.dataFim, intl, commonActions);

      if (!result.valid) {
        dispatch(commonActions.showAlerta('alerta', result.message, 3000));
        return;
      }
    }

    if (usuarioSolicitante)
      params.usuarioSolicitante = usuarioSolicitante;

    if (usuarioExecutante)
      params.usuarioExecutante = usuarioExecutante;

    dispatch(commonActions.showFadeCarregando(true));
    const response = await SolicitacaoApi.get(params, pagina);
    pagina === 1 && setTotal(response.totalItems);

    dispatch(actions.setLista(formatItens(response.data)));
    setShowBtnImprimir(response.data.length > 0);
    dispatch(commonActions.showFadeCarregando(false));

    if (response.data.length === 0)
      dispatch(commonActions.showAlerta('alerta', <IntlMessage id="dashboards.reports.noResultsFound" />, 3000));
  };

  const returnColor = status => {
    switch (status) {
      case 2:
        return colorsSystem.VERDE;
      case 1:
        return colorsSystem.AMARELO;
      default:
        return colorsSystem.VERMELHO;
    }
  };

  const formatItens = lista => {
    return lista.map(item => ({
      ...item,
      statusFormated: (
        <Badge
          style={{
            fontSize: '12px',
            backgroundColor: returnColor(item.statusEnum),
            color: `${
              item.statusEnum === statusSolicitacoesEnum.ANDAMENTO
                ? '#333'
                : '#fff'
            }`
          }}
        >
          {item.status === 'Solicitado' ? `${intl.formatMessage({id: 'general.requestsPanel.requested'})}` 
          : item.status === 'Em andamento' ? `${intl.formatMessage({id: 'general.requestsPanel.inProgress'})}`
          : item.status === 'Feito' ? `${intl.formatMessage({id: 'general.requestsPanel.done'})}` : ''}
        </Badge>
      ),
      coloracoesFormated: item.coloracoes
        ? item.coloracoes.map(c => c.nome).join(', ')
        : ''
    }));
  };

  return (
    <div>
      <ModalDetalhesSolicitacao
        showModal={showModalDetalhes}
        onModal={setShowModalDetalhes}
        itemSelecionado={itemSelecionado}
        setItemSelecionado={setItemSelecionado}
      />
      <Relatorio
        filtro={filtro}
        total={total}
        setShowModalImprimir={setShowModalImprimir}
        showModalImprimir={showModalImprimir}
      />
      <Filtro
        setFiltro={setFiltro}
        filtro={filtro}
        filtrar={filtrar}
        showBtnImprimir={showBtnImprimir}
        setShowModalImprimir={setShowModalImprimir}
      />
      {!!listaSolicitacoes.length && (
        <Grid
          totalItens={total}
          pagina={pagina}
          totalItensPage={20}
          setPagina={setPagina}
          onclickLine={onclickLine}
        />
      )}
      {!listaSolicitacoes.length && (
        <div className='icone-semdados'>
          <i className='inicial-icons mv-basico-dados_solicitacao'></i>
        </div>
      )}
    </div>
  );
}

export default Solicitacoes;



// WEBPACK FOOTER //
// ./src/pages/solicitacao/Solicitacoes/index.js